<template>
    <div>
        <el-dialog
                class="login-dialog"
                center
                :close-on-click-modal="false"
                :visible.sync="showLoginDialog"
                width="500px">
            <el-form ref="form" :model="form" label-width="90px" label-position="left">
                <el-form-item label="Login ID" prop="phone">
                    <el-input prefix-icon="el-icon-user-solid" v-model="form.account"
                              @focus="loginErr = false"></el-input>
                </el-form-item>

                <el-form-item label="Password" prop="password">
                    <el-input prefix-icon="el-icon-lock" class="pwd" v-model="form.password" @focus="loginErr = false"
                              type="password"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button class="btn" type="primary" @click="login">Login</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import {login} from '../api/AuthApi'

export default {
    name: 'Login',
    props: {
        show: {required: true}
    },
    data() {
        return {
            loginErr: false,
            form: {
                account: '',
                password: ''
            },
            showLoginDialog: this.show,
            rules: {
                phone: [{required: true, message: 'Phone is required', trigger: 'blur'}],
                password: [{required: true, message: 'Password is required', trigger: 'blur'}]
            }
        }
    },
    methods: {
        login() {
            const loginForm = {}
            if (!this.form.account.includes('@')) {
                return
            }
            loginForm.account = this.form.account.substr(0, this.form.account.indexOf("@"));
            loginForm.role = 5;
            loginForm.password = this.$md5(this.form.password)
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    login(loginForm)
                        .then((res) => {
                            const data = res.data
                            this.$store.commit('setUserInfo', data)
                            let url = '/'
                            if (data.role) {
                                switch (data.role) {
                                    case 3:
                                        url = '/ma/property'
                                        break
                                    case 5:
                                        url = '/eazable/property'
                                        break
                                }
                            }
                            this.$router.push(url);
                        }).catch((err) => {
                        this.$msgbox.alert(err.data,
                            {
                                center: true
                            }
                        )
                    })
                } else {
                    return false
                }
            })
        }
    },
    watch: {
        'show'(val) {
            this.showLoginDialog = val
        },
        'showLoginDialog'(val) {
            this.$emit('update:show', val)
        }
    }
}
</script>

<style scoped>
.container {
    margin-left: auto;
    margin-right: auto;
    margin-top: 15%;
    text-align: center;
}

.btn {
    background-color: #0a609b;
    color: white;
    margin: -20px 0 10px 0;
    border: none;
    cursor: pointer;
    width: 100%;
    font-weight: bold;
}
</style>
